'use client';

import PublicPageLayout from '@/components/layouts/PublicPageLayout';
import { copy } from '@/data/copy';
import * as Sentry from '@sentry/nextjs';
import { useEffect, useState } from 'react';
import { requestSignIn } from '@/server/actions/user';
import SpinningIcon from '@/components/icons/SpinningIcon';

export default function SignIn() {
  const [error, setError] = useState<string | null>(null);

  async function handleRequestLoginPage() {
    try {
      const { success, error } = await requestSignIn();

      if (success && success.redirect) {
        window.location.assign(success.redirect);
        return;
      }

      if (error) {
        setError(error);
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          section: '[SignInPage]',
        },
      });
      setError(copy.common.somethingWentWrong);
    }
  }

  useEffect(() => {
    handleRequestLoginPage();
  }, []);

  return (
    <PublicPageLayout
      CTAContent={
        <>
          <h1 className="text-bodydark1">
            {copy.pages.signin.ctaContent.title}
          </h1>
          <p className="text-bodydark1 mt-8">
            {copy.common.publicRoute.whoWeAre}
          </p>
        </>
      }
    >
      <div className="flex flex-col w-full h-full justify-center items-center">
        {error ? (
          <p className="text-center text-destructive max-w-sm">{error}</p>
        ) : (
          <SpinningIcon className="w-10 h-10" />
        )}
      </div>
    </PublicPageLayout>
  );
}
